import cx from 'classnames';
import {
  useCallback, useEffect, useRef, useState,
} from 'react';

import mediaQueries from '../../utils/media-query/media-query-constants';
import useMediaQuery from '../../utils/media-query/media-query-hook';
import ArrowRightShortIcon from '../SVGIcons/ArrowRightShortIcon';
import { TechDivisionsCard } from '../TechDivisionsCard';
import classes from './direction-divisions.module.scss';
import {
  DirectionDivisionsProps,
  DivisionCardProps,
} from './DirectionDivisions.type';

function DirectionDivisions({
  title,
  subtitle,
  divisionsBlockCards,
  rows = 4,
}: DirectionDivisionsProps) {
  const isMobile = useMediaQuery(mediaQueries.smallMobile);
  const [height, setHeight] = useState(0);
  const [modalData, setModalData] = useState<DivisionCardProps | null>();
  const cardsRef = useRef<HTMLDivElement>(null);
  const descriptionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateContainerHeight = () => {
      const descriptionHeight = descriptionRef.current
        ? descriptionRef.current.offsetHeight
        : 0;
      const cardsHeight = cardsRef.current ? cardsRef.current.offsetHeight : 0;

      if (modalData) {
        setHeight(descriptionHeight);
      } else {
        setHeight(cardsHeight);
      }
    };

    updateContainerHeight();

    const resizeObserver = new ResizeObserver(updateContainerHeight);
    if (descriptionRef.current) {
      resizeObserver.observe(descriptionRef.current);
    }

    if (cardsRef.current) {
      resizeObserver.observe(cardsRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [modalData]);

  const handleChooseDirection = (directions: DivisionCardProps) => {
    setModalData(directions);
  };

  const handleClose = () => {
    setModalData(null);
  };

  const isMiniCard = useCallback(
    (index: number) => {
      if (divisionsBlockCards.length === 5 && (index === 0 || index === 1)) {
        return true;
      }

      if (divisionsBlockCards.length === 4 && isMobile) {
        return true;
      }

      return false;
    },
    [isMobile, divisionsBlockCards.length],
  );

  return (
    <div className={classes.teams}>
      <div className={classes.teamsWrapper} style={{ height }}>
        <div
          className={cx(classes.teamsCard, classes.teamsCardBack, {
            [classes.hidden]: !modalData,
            [classes.visible]: modalData,
          })}
        >
          <TechDivisionsCard
            title={modalData?.detailTitle || modalData?.title || ''}
            firstSubtitle={modalData?.firstSubtitle || ''}
            firstText={modalData?.firstText || ''}
            fourthSubtitle={modalData?.fourthSubtitle || ''}
            fourthText={modalData?.fourthText || ''}
            secondSubtitle={modalData?.secondSubtitle || ''}
            secondText={modalData?.secondText || ''}
            thirdSubtitle={modalData?.thirdSubtitle || ''}
            thirdText={modalData?.thirdText || ''}
            rows={rows}
            handleClose={handleClose}
            ref={descriptionRef}
          />
        </div>
        <div
          className={cx(classes.teamsCard, {
            [classes.hidden]: modalData,
            [classes.visible]: !modalData,
          })}
          ref={cardsRef}
        >
          <div className={classes.teamsContainer}>
            <div className={classes.teamsDescription}>
              <p className={classes.heading}>{title}</p>

              <p className={classes.description}>{subtitle}</p>
            </div>

            <div className={classes.container}>
              {divisionsBlockCards.map((direction, index) => (
                <button
                  type="button"
                  key={direction.id}
                  className={cx(classes.directionCard, {
                    [classes['directionCard-mini']]: isMiniCard(index),
                  })}
                  onClick={() => handleChooseDirection(direction)}
                >
                  <p>{direction.title}</p>

                  <ArrowRightShortIcon />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DirectionDivisions;
